module.exports = "././img/Interpreter-Symbol.png";


//////////////////
// WEBPACK FOOTER
// ../assets/img/Interpreter-Symbol.png
// module id = 265
// module chunks = 0